import { cn } from "@discovery/classnames";
import * as M from "@discovery/prelude/lib/data/maybe";
import { SonicImage } from "@discovery/components-luna/lib/components/atoms/image";
import { useCallback } from "@discovery/common-dplus/lib/hooks";
import { getIsMobile } from "../../../../../utils/isMobile";
import { Icon, Icons } from "../../../../../components/atoms/icon";
import { PlaceholderImage } from "../../../../../components/atoms/placeholder-image";
import { Card as BaseCard } from "../base";
import { HeaderVariants, Tags, Typography, } from "../../../../../components/atoms/typography";
import { useUser } from "../../../../../utils/hooks";
import * as styles from "./styles.css";
export const FeaturedSecondaryCard = ({ cardData, showPlayerPopup, kebabMenuHandler, ageConstraint, isViewAll = false, }) => {
    const { name, route, id, image, packages, descriptionM = M.empty(), isFavoriteM = M.empty(), minimumAgeM = M.empty(), durationM = M.empty(), } = cardData;
    const { premiumPackagesM } = useUser();
    const premiumPackages = M.fromMaybe(premiumPackagesM, []);
    const isPremium = premiumPackages.includes(packages);
    const isFavorite = M.fromMaybe(isFavoriteM, false);
    const minimumAge = M.fromMaybe(minimumAgeM, 0);
    const isContentAccessible = ageConstraint && minimumAge >= ageConstraint;
    const onCardClick = () => {
        showPlayerPopup && showPlayerPopup(cardData);
    };
    const likeClickHandler = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
        kebabMenuHandler &&
            kebabMenuHandler(isFavorite ? "UNLIKE" : "LIKE", name, route, id, descriptionM, image);
    }, [kebabMenuHandler, isFavorite, name, route, descriptionM, image, id]);
    return (React.createElement("div", { className: cn(styles.secondaryCardDesktop, styles.featuredCard, {
            [styles.card]: isViewAll,
        }), onClick: onCardClick, id: "#secondaryCardWrapper" },
        React.createElement("div", { className: cn(styles.featuredThumbnailContainer, styles.thumbnailContainer, {
                [styles.hoverable]: !getIsMobile(),
            }), id: "#secondaryCard" },
            React.createElement("div", { className: styles.featuredPlay },
                React.createElement(Icon, { type: Icons.SearchPlayIcon, className: styles.playIcon })),
            React.createElement("div", { className: styles.hoverOverlay },
                React.createElement("div", { className: styles.basicHoverPlayIconWrapper, id: "#play-icon" },
                    React.createElement(Icon, { type: Icons.HoverPlayIcon, className: styles.basiCardhoverPlayIcon })),
                React.createElement("div", { className: styles.iconContainerHover },
                    React.createElement("div", { onClick: likeClickHandler, id: "#likeClickHandler", className: isFavorite ? styles.watchLaterWrapper : styles.likeWrapper },
                        React.createElement(Icon, { type: isFavorite ? Icons.Favorite : Icons.UnFavorite, className: styles.likeHover })))),
            React.createElement("div", { className: cn(styles.featuredImageConatiner, styles.thumbnailImageContainer) },
                React.createElement("div", { className: styles.thumbnailImageWrapper },
                    isPremium && (React.createElement(Icon, { type: Icons.PremiumMemberIcon, className: styles.premiumIcon })),
                    isContentAccessible && (React.createElement(Icon, { type: Icons.Plus18Tag, className: styles.ageConstraints })),
                    React.createElement(PlaceholderImage, null),
                    React.createElement(SonicImage, { image: image, imageSizes: {
                            default: [100, "vw"],
                            maxWidthMediaQueries: [
                                [699, "px", 120, "px"],
                                [1023, "px", 140, "px"],
                                [1439, "px", 180, "px"],
                            ],
                        }, extraImageWidths: [250, 400], className: cn(styles.thumbnailImage, styles.featuredImage), fallbackImageSize: { width: 250 }, alt: "SecondarycardImage" })),
                React.createElement("div", { className: styles.durationWeb, id: "#duratiom" },
                    React.createElement(BaseCard.Duration, { durationM: durationM })))),
        React.createElement("div", { className: styles.featuredtitleAndDuaration, id: "#cardTitle" },
            React.createElement(Typography, { classNameM: M.of(styles.title), variant: HeaderVariants.subHeadOne, tag: Tags.span },
                React.createElement(React.Fragment, null, name)))));
};

